import { useEffect, useRef } from 'react'

import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

export const SelfScrollingButton = ({ isActive, ...props }: ButtonProps & { isActive: boolean }) => {
  const btnRef = useRef<HTMLButtonElement>(null)

  // Scroll to active
  useEffect(() => {
    if (!isActive || !btnRef.current) return
    btnRef.current.scrollIntoView({ behavior: 'smooth', inline: 'center' })
  }, [isActive, btnRef])

  return (
    <Button ref={btnRef} {...props} preventFocusOnPress variant="none" size="sm">
      {props.children}
    </Button>
  )
}
